import { render } from "./ModalBlackjackRules.vue?vue&type=template&id=4fe95c35&scoped=true"
import script from "./ModalBlackjackRules.vue?vue&type=script&lang=js"
export * from "./ModalBlackjackRules.vue?vue&type=script&lang=js"

import "./ModalBlackjackRules.vue?vue&type=style&index=0&id=4fe95c35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe95c35"]])

export default __exports__